module.exports = __webpack_public_path__ + "assets/img/login.968e7f0e.png";